'use client';

import { useState } from 'react';

import { Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';

import { IntroGenerateAssignment } from '../components/intro-generate-assignment';
import { StartGenerateAssignment } from '../components/start-generate-assignment';
import { GenerateAssignmentDetailFunctions } from '../components/generate-assignment-detail-functions';

export const GenerateAssignmentSubPageView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);

  return (
    <Container>
      <IntroGenerateAssignment setOpenDemoForm={(value) => setOpenDemo(value)} />
      <CustomerElearning />
      <GenerateAssignmentDetailFunctions />
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
      <StartGenerateAssignment setOpenDemoForm={(value) => setOpenDemo(value)} />
    </Container>
  );
};
